
<template>
   <el-dialog
      :visible.sync="subVisible"
      class="preview_box"
      :modal="true"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      title="复核结果提交"
      width="597px"
      :center="true"
    >
     <el-form
            :inline="true"
            :model="submitData"
            label-width="90px"
            class="demo-form-inline online_wrap_info_line">
            <el-form-item label="经销商简称:">{{task.dealer_name}}</el-form-item>
            <el-form-item :label="task.task_status_str">{{task.auditor}}</el-form-item>
    </el-form>
    <el-form
            :inline="true"
            :model="submitData"
            label-width="80px"
            class="demo-form-inline online_wrap_info_line">
            <el-button type="default" class="btn__primary" @click="getResult">审核结果</el-button>
            <span v-show="resultShow">
                <el-form-item label="分数:">{{submitData.score}}</el-form-item>
                <el-form-item label="修改数量:">{{submitData.modify_counts}}</el-form-item>
                <el-form-item label="用时:">{{submitData.duration_minute}}</el-form-item>
            </span>

    </el-form>
    <el-divider></el-divider>
    <el-form
        :model="submitForm"
        label-width="0px"
        class="demo-form-inline edit_from"
        ref="editForm"
      >
        <el-form-item label="" prop="project" style="margin-bottom: 16px;">
              <el-button type="text" class="remarkBtn" @click="remarkShow=true">添加备注</el-button>
        </el-form-item>

        <el-form-item label="" prop="name" style="margin-bottom: 16px;" v-show="remarkShow">
          <el-input v-model="submitForm.remark" type="textarea"  placeholder="请输入备注信息"></el-input>
        </el-form-item>
        <el-form-item class="section__footer">
          <el-button type="zebra-primary" :loading="subLoading" @click="submitCheck">提交</el-button>
          <el-button class="btn__reset" type="default" @click="defaultBtn">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
</template>

<script>
export default {
  name: 'checkResult',
  props: {
    subVisible: {
      type: Boolean,
      default: false
    },
    task: {
      type: Object,
      default: {
        dealer_name: '',
        task_status_str: ''
      }
    }
  },
  created () {
  },

  data () {
    return {
      submitForm: {
        remark: ''
      },
      submitData: {
        score: '',
        duration_minute: '',
        modify_counts: ''
      },
      subLoading: false,
      task_id: Number(this.$route.query.taskId), // 任务id
      resultShow: false,
      remarkShow: false
    }
  },
  methods: {
    submitCheck () {
      this.subLoading = true
      this.$emit('submitQuestion', this.submitForm.remark)
    },
    defaultBtn () {
      this.subLoading = false
      this.submitForm.remark = ''
      this.resultShow = false
      this.remarkShow = false
      this.$emit('closeDialog')
    },
    async getResult () {
      let { data } = await this.axios.post('/home/auditor/task/calculateQuestionnaireScore', { task_id: this.task_id })
      this.resultShow = true
      const { success, results, rows = [] } = data
      if (success) {
        this.submitData = Object.assign(this.submitData, rows)
      } else {
        this.$message(results.msg)
      }
    }
  },
  deactivated () {
    this.submitForm = {
      remark: ''
    }
    this.submitData = {
      score: '',
      duration_minute: '',
      modify_counts: ''
    }
    this.subVisible = false
  },
  activated () {
    this.task_id = Number(this.$route.query.taskId)
  }
}
</script>

<style lang="scss" scoped>
.preview_box{
    /deep/.el-dialog__header{
        background: #FAFAFA;
        padding:10px 20px 10px
    }
    /deep/.el-dialog__headerbtn{
        display: none
    }
    /deep/.el-textarea .el-textarea__inner{
        min-height:80px !important
    }
}
.section__footer{
    text-align: right
}
.remarkBtn{
    color:#CCCCCC;
}
</style>
